export const SECURITY_ROLES_LIST_TYPES = {
  // initialize
  INITIALIZE_SECURITY_ROLES_LIST: 'INITIALIZE_SECURITY_ROLES_LIST',

  // set
  SET_SECURITY_ROLES_LIST: 'SET_SECURITY_ROLES_LIST',
  SET_SECURITY_ROLES_LIST_LOADING: 'SET_SECURITY_ROLES_LIST_LOADING',
};
